import { OrderChannel } from './order_channel.js';

export function name(channel: OrderChannel): string {
  switch (channel) {
    case OrderChannel.Catering:
      return 'Catering';
    case OrderChannel.DriveThru:
      return 'Drive-Thru';
    case OrderChannel.Flash:
      return 'Contactless';
    case OrderChannel.Kiosk:
      return 'Kiosk';
    case OrderChannel.Linebuster:
      return 'Linebuster';
    case OrderChannel.Web:
      return 'Web';
  }
}

// TODO: remove once we break up kiosk and flash
export function nameCombiningKioskAndFlash(channel: OrderChannel): string {
  switch (channel) {
    case OrderChannel.Kiosk:
      return 'Kiosk/Flash';
    case OrderChannel.Catering:
    case OrderChannel.DriveThru:
    case OrderChannel.Flash:
    case OrderChannel.Linebuster:
    case OrderChannel.Web:
      return name(channel);
  }
}

export function isOrderAhead(channel: OrderChannel): boolean {
  switch (channel) {
    case OrderChannel.Catering:
    case OrderChannel.Web:
      return true;
    case OrderChannel.DriveThru:
    case OrderChannel.Flash:
    case OrderChannel.Kiosk:
    case OrderChannel.Linebuster:
      return false;
  }
}

export function isKiosk(channel: OrderChannel): boolean {
  switch (channel) {
    case OrderChannel.DriveThru:
    case OrderChannel.Linebuster:
    case OrderChannel.Kiosk:
      return true;
    case OrderChannel.Catering:
    case OrderChannel.Web:
    case OrderChannel.Flash:
      return false;
  }
}

/**
 * Whether KOR watches the kiosks at a location on this channel: the kiosk channels, minus
 * Linebuster. Linebuster devices are handhelds that staff turn off and carry out of range, so
 * their outages are noise, not incidents. The other channels have no kiosks.
 */
export function isKorMonitored(channel: OrderChannel): boolean {
  switch (channel) {
    case OrderChannel.DriveThru:
    case OrderChannel.Kiosk:
      return true;
    case OrderChannel.Catering:
    case OrderChannel.Flash:
    case OrderChannel.Linebuster:
    case OrderChannel.Web:
      return false;
  }
}

/** For `orderChannel: { $nin: korExcludedOrderChannels }` location filters. */
export const korExcludedOrderChannels: readonly OrderChannel[] = Object.values(OrderChannel).filter(
  (channel) => !isKorMonitored(channel),
);

export function isFlash(channel: OrderChannel): boolean {
  switch (channel) {
    case OrderChannel.Catering:
    case OrderChannel.Kiosk: // @todo: remove once we break up kiosk and flash
    case OrderChannel.Flash:
    case OrderChannel.Web:
      return true;
    case OrderChannel.DriveThru:
    case OrderChannel.Linebuster:
      return false;
  }
}
